export default "__VITE_ASSET__Iwiu5DLu__"